import React from 'react';

export default [{
  displayName: 'Events',
  description: (
    <div>
      For subscribed/assigned events as well as events you have created/commented on,
      manage when during the lifecycle you would like to receive notifications.
    </div>
  ),
  key: 'events',
  roles: [], // any user gets this
}, {
  displayName: 'Mentions',
  description: (
    <div>
      For any situation where you are mentioned
    </div>
  ),
  key: 'mentions',
  roles: [], // any user gets this
}, {
  displayName: 'Organization',
  description: (
    <div>
      For organizational communication,
      manage when you would like to receive notifications.
    </div>
  ),
  key: 'organization',
  roles: ['admin', 'owner'],
}];
